import React, { Component } from 'react';
import firebase from '../../Firebase/firebase';
import { logActivity, allowedUsers } from '../Utilities';

class Register extends Component {
  state = {
    email: '',
    password: '',
    error: null,
  };

  componentDidMount = () => {
    // logActivity([
    //   {
    //     "screen": "Login",
    //     "module": "Login Page",
    //     "user_activity": "user registration",
    //     "timestamp": new Date().toISOString()
    //   }
    // ])
  }

  handleInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmit = (event) => {
    // check users
    const userLen = allowedUsers.length
    var isUserAllowed = false
    for (let i = 0; i < userLen; i++) {
      if (this.state.email === allowedUsers[i]) {
        isUserAllowed = true
        break
      }
    }

    if (isUserAllowed) {
      event.preventDefault();
      const { email, password } = this.state;

      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then((user) => {})
        .catch((error) => {
          this.setState({ error: error });
        });
    } else {
      event.preventDefault();
      alert("You have no access to use this application");
      this.setState({
        email: "",
        password: "",
        error: null,
      });
    }

  };
  render() {
    const { email, password, error } = this.state;
    return (
      <div className="container-fluid" style={{ width: '50%' }}>
        <div className="row">
          <div className="col">
            <h4>Register</h4>
          </div>
        </div>
        {error ? (
          <div className="row">
            <div className="col">
              <span>{error.message}</span>
            </div>
          </div>
        ) : null}
        <div className="row">
          <div className="col">
            <form onSubmit={this.handleSubmit} className="form-group">
              <input type="text" name="email" className="form-control" placeholder="Email" value={email} onChange={this.handleInputChange} />
              <br /><input
                type="password"
                name="password"
                placeholder="Password"
                value={password}
                onChange={this.handleInputChange}
                className="form-control"
              />
              <br />
              <button className="btn btn-primary"> Register</button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default Register;
